export default {
  'ComparisonNav.title': 'items in comparison',
}
